import {
  apiClient,
  type CreateGenericShipmentOrderImportJobDto,
  type ShipmentOrderImportJobExEntity
} from '@/libs/api'

/** 取り込み設定（マッピング・確認画面での修正・除外）付きで取込ジョブを作る。 */
export const createGenericShipmentOrderImportJob = async (
  tenantKey: string,
  body: CreateGenericShipmentOrderImportJobDto
): Promise<ShipmentOrderImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_jobs.generic.$post({ body })
  return data
}
